import { Plus } from 'lucide-react';

import { FilterCondition } from './components/FilterCondition';
import { Filter } from './Filter';

import { LogicalOperator, type SavedQueryBody } from '@/entities/query/types';
import { Badge } from '@/shared/components/shadcn/badge';
import { Button } from '@/shared/components/shadcn/button';

interface Props {
  filterForm: SavedQueryBody;
  onChange: (filter: SavedQueryBody) => void;
}

export function QueryFilterForm({ filterForm, onChange }: Props) {
  return (
    <div className="flex flex-col gap-6">
      <div className="bg-card flex flex-col rounded-lg border">
        <div className="flex flex-col gap-6 p-6">
          <span className="text-base font-medium">Include keywords</span>
          {filterForm.filter.include.map((include, index, array) => (
            <div className="flex flex-col gap-6" key={index}>
              <Filter
                className="rounded-lg"
                type="include"
                data={include}
                showDeleteButton={array.length > 1}
                onDelete={() => {
                  onChange({
                    ...filterForm,
                    filter: {
                      ...filterForm.filter,
                      include: filterForm.filter.include.filter((_, i) => i !== index),
                    },
                  });
                }}
                onChange={(includeFilter) => {
                  onChange({
                    ...filterForm,
                    filter: {
                      ...filterForm.filter,
                      include: filterForm.filter.include.map((include, i) =>
                        i === index ? includeFilter : include,
                      ),
                    },
                  });
                }}
              />

              {array.length !== index + 1 && (
                <div className="flex justify-center">
                  <Badge variant="secondary">AND</Badge>
                </div>
              )}
            </div>
          ))}
        </div>
        <div
          className="bg-secondary flex cursor-pointer px-6 py-2"
          onClick={() => {
            onChange({
              ...filterForm,
              filter: {
                ...filterForm.filter,
                include: [
                  ...(filterForm.filter.include || []),
                  { op: LogicalOperator.Or, values: [] },
                ],
              },
            });
          }}
        >
          <Button variant="secondary" size="default">
            <Plus />
            Add Group
          </Button>
        </div>
      </div>

      <Filter
        className="rounded-lg"
        title="Exclude keywords"
        type="exclude"
        data={filterForm.filter.exclude}
        onChange={(excludeFilter) => {
          onChange({
            ...filterForm,
            filter: {
              ...filterForm.filter,
              exclude: {
                op: excludeFilter.op || LogicalOperator.Or,
                values: excludeFilter.values || [],
              },
            },
          });
        }}
      />
      <FilterCondition
        options={filterForm.options}
        onChange={(options) => onChange({ ...filterForm, options })}
      />
    </div>
  );
}
